import React, { useState, useEffect } from 'react';
import { Eye, EyeOff } from "lucide-react"; 
import Input from "../props/inputProp";


const PasswordGate = ({ onAccessGranted }) => {

    const [input, setInput] = useState('');
    const [error, setError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
  

    useEffect(() => {
        const hasAccess = localStorage.getItem('hasAccess');
        if (hasAccess === 'true') {
        onAccessGranted();
        }
    }, [onAccessGranted]);


    const handleSubmit = (e) => {
        e.preventDefault();
        const correctPassword = process.env.REACT_APP_ACCESS_PASSWORD;

        if (input === correctPassword) {
        localStorage.setItem('hasAccess', 'true'); // Makes it persistant 
        onAccessGranted();
        } else {
        setError(true);
        setTimeout(() => setError(false), 500);
        }
    };

    const handleChange = (event)=>{
        setInput(event.target.value);
    }

  return (
    <div className="password-container">

        <label className="label passwordInputs enterPassword">
            <div className="passwordLabelDetail ">
                Enter Access Password<span className="asterisk"> *</span>
            </div>
            <div className="eyeContainer">
                <span 
                    className="showHideIcon" 
                    onClick={() => setShowPassword(!showPassword)}
                >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </span>
            </div>
            
        </label>

        <form onSubmit={handleSubmit} className={`password-form ${error ? 'shake' : ''}`}>
            
            <Input
                className="password"
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="........"
                autoCapitalize="off"
                autoCorrect="off"
                required
                onChange={handleChange}
            />
            <button type="submit" className="password-button">
            Enter
            </button>
        </form>
        {error && <p className="error-text">Incorrect password</p>}
    </div>
  );
};

export default PasswordGate;
